import { render, staticRenderFns } from "./GridButtonProviderBuilder.vue?vue&type=template&id=31c826b9&"
import script from "./GridButtonProviderBuilder.vue?vue&type=script&lang=js&"
export * from "./GridButtonProviderBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports